import { render } from "./TheNavbar.vue?vue&type=template&id=b219c944&scoped=true"
import script from "./TheNavbar.vue?vue&type=script&lang=js"
export * from "./TheNavbar.vue?vue&type=script&lang=js"

import "./TheNavbar.vue?vue&type=style&index=0&id=b219c944&scoped=true&lang=scss"

import exportComponent from "/home/tachyon/wardrobe-test2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b219c944"]])

export default __exports__